import { Box, IconButton, Link, Stack, Typography, useTheme } from "@mui/material"
import EmailIcon from '@mui/icons-material/Email';
import { ReactComponent as VkIcon } from '../icons/VkIcon.svg'


const ContactsPage = () => {
    const email = 'Geroiyar';
    const domain = 'yarregion.ru';
    const theme = useTheme()
    return (
        <>
            <Typography variant="h1">Контакты</Typography>

            <Stack direction='row' alignItems='center' spacing={1}>
                <Stack sx={{ padding: '4px' }}>
                    <EmailIcon sx={{ color: 'primary.main' }} />
                </Stack>
                <Link href={`mailto:${email}@${domain}`} title='Написать на почту'>
                    {`${email}@${domain}`}
                </Link>
            </Stack>

            <Stack direction='row' alignItems='center' spacing={1}>
                <VkIcon
                    fontSize="small"
                    style={{ fill: theme.palette.primary.main }}
                />
                <Link target='_blank' href='https://vk.com/geroiyaroslavii' title='ВК Герои Ярославии '>
                    vk.com/geroiyaroslavii
                </Link>
            </Stack>
        </>
    )
}

export default ContactsPage
